import { mountVacancyBanner } from 'src/parts/vacancy_banner.js';
import { VacanciesUserFiltersResource } from 'src/services/vacancies.js';
import { getSsrState } from 'src/utils/ssr.js';
import { getFormattedNumber } from 'src/utils/translation.js';
import { createVueApp } from 'src/utils/vue.js';

import DisableCaptchaProvider from 'src/components/DisableCaptchaProvider/DisableCaptchaProvider.vue';
import FiltersProvider from 'src/components/filters/FiltersProvider/FiltersProvider.vue';
import SavedFiltersProvider from 'src/components/filters/SavedFiltersProvider/SavedFiltersProvider.vue';
import VisitorProvider from 'src/components/users/VisitorProvider/VisitorProvider.vue';
import VacancyListPage from 'src/components/vacancies/VacancyListPage/VacancyListPage.vue';

import 'styles/views/shared/sidebar/best_companies.css.sass';
import 'styles/views/shared/sidebar/inner_project_banner.css.sass';
import 'styles/parts/forms.css.sass';

const models = {
  currency: {
    default: 'RUR',
    isSelected: () => false,
  },
  salary: {
    title: ({ options, filters, value }) => {
      const salary = getFormattedNumber(value);
      const currency = options.currency.find(
        (item) => item.value === filters.currency,
      ).title;
      return `От ${salary} ${currency}`;
    },
  },
  hasSalary: {
    title: 'Указана зарплата',
  },
  remoteWork: {
    title: 'Можно удалённо',
  },
  has_accreditation: {
    title: 'С аккредитацией',
  },
  company: {
    title: ({ filters, title }) => {
      if (filters.excludeCompany) return `${title} (исключить)`;

      return title;
    },
  },
  excludeCompany: {
    isSelected: () => false,
  },
};

const {
  isGuest,
  type,
  tabs,
  vacancies,
  search,
  options,
  subscriptions,
  showSeoButton,
  showUpdateSeoButton,
  ignoreFilterSync,
  alias,
  headerText,
  similarVacancies,
  filtersData: dynamicOptions,
  recommendedQuickVacancies: quickResponseVacancies = [],
  showRecVacanciesFeedback: quickResponseShowFeedback,
  skillsBanner,
  disableCaptcha,
} = getSsrState();

const {
  query,
  order,
  filters,
  suggestedFilters,
  savedFilters,
  groups,
} = search;

const app = createVueApp({
  render(h) {
    return h(DisableCaptchaProvider, { props: { disableCaptcha } }, [
      h(VisitorProvider, { props: { visitor: { isGuest } } }, [
        h(
          FiltersProvider,
          {
            props: {
              filters,
              options,
              dynamicOptions,
              models,
              groups,
            },
          },
          [
            h(
              FiltersProvider,
              {
                props: {
                  name: 'suggestedFilters',
                  filters: suggestedFilters,
                  options,
                  dynamicOptions,
                  models,
                  groups,
                },
              },
              [
                h(
                  SavedFiltersProvider,
                  {
                    props: {
                      savedFilters,
                      resource: VacanciesUserFiltersResource,
                    },
                  },
                  [
                    h(VacancyListPage, {
                      props: {
                        type,
                        tabs,
                        vacancies,
                        query,
                        order,
                        showSeoButton,
                        showUpdateSeoButton,
                        subscriptions,
                        ignoreFilterSync,
                        alias,
                        headerText,
                        similarVacancies,
                        quickResponseVacancies,
                        quickResponseShowFeedback,
                        groups,
                        skillsBanner,
                      },
                    }),
                  ],
                ),
              ],
            ),
          ],
        ),
      ]),
    ]);
  },
});

app.$mount('[data-vacancy-list]');

mountVacancyBanner(getSsrState());
